import axios from "axios";
import type { DeepPartial } from "typeorm";

import type { Notification, NotificationContent } from "@virtual-brain-lib/types";

import env from "../environments";

export async function getNotifications() {
	const response = await axios.get<Notification[]>(`${env.apiUrl}/notifications`);

	return response.data;
}

export async function getNotification(notificationId: string) {
	const response = await axios.get<Notification>(`${env.apiUrl}/notifications/${notificationId}`);

	return response.data;
}

export async function createNotification(notification: DeepPartial<Notification>) {
	const response = await axios.post<Notification>(`${env.apiUrl}/notifications`, notification);

	return response.data;
}

export async function atomicNotificationContentUpdate(
	notificationId: string,
	content: Partial<NotificationContent>,
) {
	const response = await axios.put<Notification>(
		`${env.apiUrl}/notifications/atomic/${notificationId}`,
		content,
	);

	return response.data;
}

export async function updateNotification(notification: Partial<Notification> & { id: string }) {
	const response = await axios.put<Notification>(
		`${env.apiUrl}/notifications/${notification.id}`,
		notification,
	);

	return response.data;
}

export async function clearAllNotifications() {
	await axios.delete(`${env.apiUrl}/notifications/all`);
}
